import { getLanguagesByAirlineToken as getLanguages, checkAirlineToken as checkToken } from '@/api/airline'
import { sendSMSVirtualHelpDesk as sendSMS, confirmDetailsVirtualHelpdesk, searchPax, modifyGroup, searchFlight } from '@/api/passenger'

const getLanguagesByAirlineToken = (context, request) => {
  return getLanguages(request).then((response) => {
    context.commit('LANG_UPDATED', response, { root: true })
  })
}

const checkAirlineToken = (context, request) => {
  return checkToken(request).then((response) => {
    context.commit('AIRLINE_UPDATED', response, { root: true })
    return response
  })
}

const searchPassenger = (context, params) => {
  return searchPax(params).then((response) => {
    return response
  })
}

const modifyGroupPax = (context, params) => {
  return modifyGroup(params).then((response) => {
    return response
  })
}

const sendSMSVirtualHelpdesk = (context, params) => {
  return sendSMS(params).then((response) => {
    return response
  })
}

const confirmDetails = (context, params) => {
  return confirmDetailsVirtualHelpdesk(params).then((response) => {
    return response
  })
}
const searchListFlight = (context, params) => {
  return searchFlight(params).then((response) => {
    return response
  })
}
export default {
  getLanguagesByAirlineToken,
  checkAirlineToken,
  sendSMSVirtualHelpdesk,
  searchPassenger,
  confirmDetails,
  modifyGroupPax,
  searchListFlight
}
